export default __webpack_public_path__ + "static/media/logo.3b8b09ac.png";